module.exports = __webpack_public_path__ + "b7005c9823656f0607a9ca6b44978c08.fbx";